import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FilterOption, FilterSettings} from "../filter"

@Component({
    template: '',
})
export class FilterComponent {

    @Input('filterInputs')
    public FilterInputs: any;

    @Input('filterSettings')
    public FilterSettings: FilterSettings;

    @Output('filterSettingsChange')
    public FilterSettingsChange = new EventEmitter<FilterSettings>();

    @Output('filterInputComplete')
    public FilterInputComplete = new EventEmitter<any>();

    @Input('autofocus')
    public Autofocus: boolean;
    
    public compareFilterOptions(v1: FilterOption, v2: FilterOption) {
        return !!v1 == !!v2 && (!v1 || v1.Name == v2.Name);
    }
}